import React from "react";

const SetupIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="var(--text-color)"
      d="M19.43 12.98a7.98 7.98 0 0 0 .07-.98 7.98 7.98 0 0 0-.07-.98l2.11-1.65a.5.5 0 0 0 .12-.64l-2-3.46a.5.5 0 0 0-.6-.22l-2.49 1a7.94 7.94 0 0 0-1.7-.98l-.38-2.65A.5.5 0 0 0 14 2h-4a.5.5 0 0 0-.49.42l-.38 2.65a7.94 7.94 0 0 0-1.7.98l-2.49-1a.5.5 0 0 0-.6.22l-2 3.46a.5.5 0 0 0 .12.64L4.57 11a7.98 7.98 0 0 0-.07.98c0 .33.02.66.07.98l-2.11 1.65a.5.5 0 0 0-.12.64l2 3.46a.5.5 0 0 0 .6.22l2.49-1c.52.4 1.1.73 1.7.98l.38 2.65A.5.5 0 0 0 10 22h4c.25 0 .46-.18.49-.42l.38-2.65c.6-.25 1.18-.58 1.7-.98l2.49 1a.5.5 0 0 0 .6-.22l2-3.46a.5.5 0 0 0-.12-.64l-2.11-1.65ZM12 15a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z"
      opacity="0.8"
    />
  </svg>
);

export default SetupIcon;
